import AssetLog, { IAssetLog, IAssetLogApiModel } from '@models/AssetLog.model';
import { IPaginationResult } from '@models/Equipment.model';
import { api } from '@services';

export interface IPagination {
  page: number;
  limit: number;
}
interface IRequest {
  pagination?: IPagination;
  studioId?: string;
}
export const getActivityHistory = async ({
  pagination,
  studioId,
}: IRequest): Promise<IPaginationResult<IAssetLog>> => {
  const { data: activityHistory } = await api.get<
    IPaginationResult<IAssetLogApiModel>
  >(
    `/equipments/${studioId}/studioAssetHistory?page=${
      pagination?.page || 1
    }&limit=${pagination?.limit || 20}`,
  );
  return AssetLog.arrayPaginatedFromApiModel(activityHistory);
};
